let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eX3M9")).then(() => parcelRequire('jbDii'));